import React from 'react';

import { getFormattedPercentage } from '@lyearn/core/utils/number/getFormattedPercentage';
import { TFunction } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { CircularProgress, Divider, Stack, Typography } from '@lyearn/ui';
import { QuizResultEnum } from '@/types/schema';

import { progressIconStyles } from './styles';

interface RenderScoreInfoParams {
  t: TFunction;
  scorePercentage: number;
  passingPercentage: number;
  result?: QuizResultEnum | null;
}

export const renderScoreInfo = ({
  t,
  scorePercentage,
  passingPercentage,
  result,
}: RenderScoreInfoParams) => {
  return (
    <Stack direction="row" gapX={24}>
      <Stack direction="col" gapY={6}>
        <Typography color="text-text-secondary" variant="body-short-02">
          {t('QuizPlayer:Result')}
        </Typography>
        <Stack alignItems="center" gapX={8}>
          <CircularProgress
            className={cn('w-24 h-24', progressIconStyles)}
            color="success"
            overrides={{
              progressColor: result === QuizResultEnum.Pass ? undefined : 'text-icon-error',
            }}
            size="x-small"
            value={scorePercentage}
          />
          <Typography color="text-text-paragraph" variant="heading-m">
            {getFormattedPercentage(scorePercentage)}
          </Typography>
        </Stack>
      </Stack>
      <Divider orientation="vertical" />
      <Stack direction="col" gapY={6}>
        <Typography color="text-text-secondary" variant="body-short-02">
          {t('QuizPlayer:PassCutoff')}
        </Typography>
        <Typography color="text-text-paragraph" variant="heading-m">
          {`${passingPercentage}%`}
        </Typography>
      </Stack>
    </Stack>
  );
};

export const RESULT_CONFIG = {
  [QuizResultEnum.Fail]: 'QuizPlayer:Failed',
  [QuizResultEnum.Pass]: 'QuizPlayer:Passed',
};
